import React from "react";
import { SearchTag, State } from "../GlobalForm";
import { ItemClickProps } from "../GlobalFormModal";
import Companies from "./Companies";
import CustomerInteractions from "./CustomerInteractions";
import Customers from "./Customers";
import OnlineTransactions from "./OnlineTransactions";
import Redemptions from "./Redemptions";
import Transfers from "./Transfers";

type Props = {
  activeTag: SearchTag;
  state: State;
  handleItemClick: (item: ItemClickProps) => void;
  handleRetry: (query: string) => void;
};

export default function SearchResults({
  activeTag,
  state,
  handleItemClick,
  handleRetry,
}: Props): JSX.Element {
  const retry = () => handleRetry(state.searchTerm);

  switch (activeTag) {
    case SearchTag.CUSTOMERS:
      return (
        <Customers
          handleRetry={retry}
          customers={state.customers}
          loading={state.loading}
          onCustomerClick={handleItemClick}
        />
      );
    case SearchTag.CLIENTS:
      return (
        <Companies
          handleRetry={retry}
          companies={state.companies}
          loading={state.loading}
          onCompanyClick={handleItemClick}
        />
      );

    case SearchTag.REDEMPTIONS:
      return (
        <Redemptions
          handleRetry={retry}
          redemptions={state.redemptions}
          loading={state.loading}
          onRedemptionClick={handleItemClick}
        />
      );

    case SearchTag.TRANSFERS:
      return (
        <Transfers
          handleRetry={retry}
          transfers={state.transfers}
          loading={state.loading}
          onTransferClick={handleItemClick}
        />
      );

    case SearchTag.ONLINE_TRANSACTIONS:
      return (
        <OnlineTransactions
          handleRetry={retry}
          onlineTransactions={state.onlineTransactions}
          loading={state.loading}
          onTransactionClick={handleItemClick}
        />
      );

    case SearchTag.CUSTOMER_INTERACTIONS:
      return (
        <CustomerInteractions
          handleRetry={retry}
          customerInteractions={state.customerInteractions}
          loading={state.loading}
          onInteractionClick={handleItemClick}
        />
      );

    default:
      return <div>No results found</div>;
  }
}
